export default {
	'search-item-id-or-name': 'Öğe kimliği ya da adını ara',
	'show-main-item': 'Shwow Ana öğe',
	'items-with-quantities-only': 'Yalnızca miktarları olan ürünler',
	'store-items': 'Depo',
	'inventory-matching': 'Envanter eşleşmesi'
}